import * as ko from 'knockout';

import SubmitButtonBindableArgs from './submitButtonBindableArgs';

export default class SubmitButtonBindable {
    public readonly buttonText: ko.Computed<string>;
    public readonly canSubmit: ko.Computed<boolean>;
    public readonly submitting: ko.Observable<boolean> = ko.observable(false);

    private readonly _submitFunc: () => void;

    private readonly _buttonText: string;
    private readonly _loadingText: string;

    constructor(args: SubmitButtonBindableArgs) {
        this._buttonText = args.buttonText;
        this._loadingText = args.loadingText;

        this.buttonText = ko.computed(this._computeButtonText, this);
        this.canSubmit = ko.computed(() => !this.submitting() && args.computeCanSubmit());
        this._submitFunc = args.submit;
    }

    public submit(): void {
        this.submitting(true);
        this._submitFunc();
    }

    private _computeButtonText(): string {
        var text: string;
        if (this.submitting()) {
            text = this._loadingText;
        }
        else {
            text = this._buttonText;
        }
        return text;
    }
}